export const ASSET_LAST_UPLOAD_GET_DATA = 'ASSET_LAST_UPLOAD_GET_DATA'
export const ASSET_LAST_UPLOAD_GET_DATA_SUCCESS = 'ASSET_LAST_UPLOAD_GET_DATA_SUCCESS'
export const ASSET_LAST_UPLOAD_GET_DATA_FAILURE = 'ASSET_LAST_UPLOAD_GET_DATA_FAILURE'
export const ASSET_LAST_UPLOAD_EMPTY = 'ASSET_LAST_UPLOAD_EMPTY'

export const ASSET_LAST_UPLOAD_SET_SELECT = 'ASSET_LAST_UPLOAD_SET_SELECT'
export const ASSET_LAST_UPLOAD_UNSET_SELECT = 'ASSET_LAST_UPLOAD_UNSET_SELECT'
export const ASSET_LAST_UPLOAD_ACTIVEVIEW = 'ASSET_LAST_UPLOAD_ACTIVEVIEW'

export const ASSET_LAST_UPLOAD_EDIT_UNSET_SELECT = 'ASSET_LAST_UPLOAD_EDIT_UNSET_SELECT'
export const ASSET_LAST_UPLOAD_EDIT_SELECT = 'ASSET_LAST_UPLOAD_EDIT_SELECT'
export const ASSET_LAST_UPLOAD_EDIT = 'ASSET_LAST_UPLOAD_EDIT'
export const ASSET_LAST_UPLOAD_EDIT_SUCCESS = 'ASSET_LAST_UPLOAD_EDIT_SUCCESS'
export const ASSET_LAST_UPLOAD_EDIT_FAILURE = 'ASSET_LAST_UPLOAD_EDIT_FAILURE'

export const ASSET_LAST_UPLOAD_DELETE = 'ASSET_LAST_UPLOAD_DELETE'
export const ASSET_LAST_UPLOAD_DELETE_SUCCESS = 'ASSET_LAST_UPLOAD_DELETE_SUCCESS'
export const ASSET_LAST_UPLOAD_DELETE_FAILURE = 'ASSET_LAST_UPLOAD_DELETE_FAILURE'

export const ASSET_LAST_UPLOAD_EXPAND_SELECT = 'ASSET_LAST_UPLOAD_EXPAND_SELECT'
export const ASSET_LAST_UPLOAD_EXPAND_UNSET_SELECT = 'ASSET_LAST_UPLOAD_EXPAND_UNSET_SELECT'

export const ASSET_LAST_UPLOAD_SHARE_SELECT = 'ASSET_LAST_UPLOAD_SHARE_SELECT'
export const ASSET_LAST_UPLOAD_SHARE_UNSET_SELECT = 'ASSET_LAST_UPLOAD_SHARE_UNSET_SELECT'

export const ASSET_LAST_UPLOAD_MOVE = 'ASSET_LAST_UPLOAD_MOVE'
export const ASSET_LAST_UPLOAD_MOVE_SUCCESS = 'ASSET_LAST_UPLOAD_MOVE_SUCCESS'
export const ASSET_LAST_UPLOAD_FAILURE = 'ASSET_LAST_UPLOAD_FAILURE'

export const ASSET_LAST_UPLOAD_CHECK_SELECT = 'ASSET_LAST_UPLOAD_CHECK_SELECT'
export const ASSET_LAST_UPLOAD_UNCHECK_SELECT = 'ASSET_LAST_UPLOAD_UNCHECK_SELECT'

export const MULTIPLE_LAST_UPLOAD_OPTIONS_ACTIVATE = 'MULTIPLE_LAST_UPLOAD_OPTIONS_ACTIVATE'
export const MULTIPLE_LAST_UPLOAD_OPTIONS_DEACTIVATE = 'MULTIPLE_LAST_UPLOAD_OPTIONS_DEACTIVATE'
export const MULTIPLE_LAST_UPLOAD_OPTIONS_DONE = 'MULTIPLE_LAST_UPLOAD_OPTIONS_DONE'

export const ASSET_LAST_UPLOAD_UPDATE_FROM_PERMISSION = 'ASSET_LAST_UPLOAD_UPDATE_FROM_PERMISSION'

export const ASSETS_LAST_UPLOAD_MULTI_DELETE = 'ASSETS_LAST_UPLOAD_MULTI_DELETE'
export const ASSETS_LAST_UPLOAD_MULTI_DELETE_SUCCESS = 'ASSETS_LAST_UPLOAD_MULTI_DELETE_SUCCESS'
export const ASSETS_LAST_UPLOAD_MULTI_DELETE_FAILURE = 'ASSETS_LAST_UPLOAD_MULTI_DELETE_FAILURE'

export const ASSETS_LAST_UPLOAD_MULTI_MOVE = 'ASSETS_LAST_UPLOAD_MULTI_MOVE'
export const ASSETS_LAST_UPLOAD_MULTI_MOVE_SUCCESS = 'ASSETS_LAST_UPLOAD_MULTI_MOVE_SUCCESS'
export const ASSETS_LAST_UPLOAD_MULTI_MOVE_FAILURE = 'ASSETS_LAST_UPLOAD_MULTI_MOVE_FAILURE'